import React from 'react';

import styled from 'styled-components';

import { getModelAge, isBirthday, isMinor } from '@libs/NwMoment';

import NwIcon from '@components/Gui/NwIcon';
import { NwTag } from '@components/Gui/NwTag';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ModelAgeContainer = styled.div`
    font-weight: ${(props) => (props.$isBold ? 'bold' : 'normal')};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    text-transform: uppercase;
    font-size: ${(props) => (props.$small ? props.theme.FontSizeSm : props.theme.FontSizeBase)};

    @media only screen and (max-width: 720px) {
        font-size: 0.75rem;
    }

    .icon-container {
        width: 0.75rem;
        text-align: center;
    }

    p {
        margin: 0;
    }
`;

const ModelDetailsAge = ({ birthday, nofixedspace, small }) => {
    if (!birthday) return null;

    const isBD = birthday ? isBirthday(birthday) : false;
    const isM = birthday ? isMinor(birthday) : false;
    const modelAge = birthday ? getModelAge(birthday) : null;

    return (
        <ModelAgeContainer $isBold={isBD} $small={small}>
            {(!nofixedspace || isBD) && (
                <div className="icon-container">{isBD && <NwIcon icon={byPrefixAndName.fasl['birthday-cake']} />}</div>
            )}
            <p>{isM ? <NwTag type="danger">{modelAge}</NwTag> : <>{modelAge}</>}</p>
        </ModelAgeContainer>
    );
};

export default ModelDetailsAge;
